/**
 * Customer Backoffice API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * <p><i>Description of values:</i></p><p>* <code>InvalidEmail</code> - Invalid email</p><p>* <code>InvalidPassword</code> - Invalid password</p><p>* <code>AWSUserAlreadyRegistered</code> - AWS user already has a Clinical Brain account</p><p>* <code>EmailAlreadyRegistered</code> - Email is already registered</p><p>* <code>InvalidAWSToken</code> - Invalid AWS token</p>
 */
export enum RegisterAWSErrorCode {
    InvalidEmail = 'InvalidEmail',
    InvalidPassword = 'InvalidPassword',
    AwsUserAlreadyRegistered = 'AWSUserAlreadyRegistered',
    EmailAlreadyRegistered = 'EmailAlreadyRegistered',
    InvalidAwsToken = 'InvalidAWSToken'
}

